const PORTAL_PREFIX = 'olistds';

export { PORTAL_PREFIX };
